module.exports = __webpack_public_path__ + "img/uk-roots.8dcddde3.png";